<template>
    <div>
        <template v-if="corporate_change_password === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <div class="page-top float-left">
                    <h1 class="m-0">Account Balance: <span class="highlight-color"> (PKR{{formatAmount(account_balance)}})</span> </h1>
                </div>
            </div>
            <div class="corporate-main">
                <div class="corporate-head pb-3 clearfix">
                    <h3 class="change-password-head float-left">Change Password</h3>
                </div>
                <form @submit.prevent="changePassword">
                    <div class="corporate-content mt-5 pt-5 pb-5">
                        <div class="form-group mb-3">
                            <input v-model="form.oldPassword" type="password" name="oldPassword" class="form-control" :class="{ 'is-invalid': form.errors.has('oldPassword') }" autocomplete="off" placeholder="Old Password">
                            <has-error :form="form" field="oldPassword"></has-error>
                        </div>
                        <div class="form-group mb-3">
                            <input v-model="form.password" type="password" name="password" class="form-control" :class="{ 'is-invalid': form.errors.has('password') }" autocomplete="off" placeholder="Password">
                            <has-error :form="form" field="password"></has-error>
                        </div>
                        <div class="form-group mb-3">
                            <input v-model="form.password_confirmation" type="password" name="password_confirmation" class="form-control" :class="{ 'is-invalid': form.errors.has('password_confirmation') }" autocomplete="off" placeholder="Confirm Password">
                            <has-error :form="form" field="password_confirmation"></has-error>
                        </div>
                        <button :disabled="form.busy" class="btn btn-primary active"> Update </button>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="corporate_change_password === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="corporate_change_password === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    password : '',
                    password_confirmation : '',
                    oldPassword : '',
                }),
                account_balance : '',
                corporate_change_password: null
            };
        },
        methods: {
            changePassword(){
                this.$Progress.start();
                this.form.post("/api/corporateChangePassword")
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','Password successfully changed.');
                            this.$router.push('/corporateLogin');
                        }else if(res.data.status == 400){
                            this.$Progress.fail();
                            this.showToastBox('error',res.data.msg);
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','System is not responding! Please try again later.');
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','System is not responding! Please try again later.');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
        },
        mounted() {
            // this.$Progress.start();
			this.can('corporate_change_password').then(result => {
                axios.get("/api/checkSessionData")
                .then(res => {
                    if(res.status == 200){
                        // this.$Progress.finish();
                        if(res.data.status == 201){
                            this.$router.push('/corporateLogin');
                        }else{
                            this.account_balance = res.data.accountDetail.balance;
                            this.corporate_change_password = result.corporate_change_password;
                        }
                    }else{
                        // this.$Progress.fail();
                        this.showAlertBox('error','System is not responding! Please try again later.');
                    }
                })
                .catch(err => {
                    // this.$Progress.fail();
                    this.showAlertBox('error','System is not responding! Please try again later.');
                });
            });
        },
    }
</script>
